import React from 'react';
import PropTypes from 'prop-types';
import Mosvita from '../../ui/typography/mosvita';
import { ContainerDetailText } from './style';
import { HtmlRaw } from '../../components';

const DetailText = ({ text, number }) => (
  <ContainerDetailText>
    <Mosvita type="detailTextNumber">{number}</Mosvita>
    <Mosvita type="detailText">
      <HtmlRaw html={text} />
    </Mosvita>
  </ContainerDetailText>
);

DetailText.propTypes = {
  text: PropTypes.string,
  number: PropTypes.string
};

export default DetailText;
